import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function FeaturesSection() {
  const { t } = useTranslation();

  const features = [
    {
      title: t('features.items.0.title'),
      image: 'https://readdy.ai/api/search-image?query=Black%20African%20telecommunications%20engineers%20installing%20steel%20lattice%20telecom%20tower%20in%20African%20landscape%2C%20professional%20Black%20technicians%20working%20on%20cellular%20network%20infrastructure%20with%20safety%20helmets%20and%20harnesses%2C%20modern%20telecom%20deployment%20with%20clear%20bright%20sky%2C%20warm%20natural%20daylight%20with%20detailed%20technical%20scene&width=848&height=520&seq=feat-tel-towers-01&orientation=landscape',
      link: '/telecom-infrastructures',
    },
    {
      title: t('features.items.1.title'),
      image: 'https://readdy.ai/api/search-image?query=Black%20African%20construction%20workers%20and%20civil%20engineers%20building%20steel%20metal%20framework%20for%20industrial%20infrastructure%20in%20Africa%2C%20professional%20BTP%20construction%20site%20with%20welding%20equipment%20and%20reinforced%20concrete%20foundations%2C%20warm%20natural%20daylight%2C%20professional%20industrial%20photography%20with%20African%20workers%20in%20safety%20gear&width=848&height=520&seq=feat-btp-01&orientation=landscape',
      link: '/genie-civil-btp',
    },
    {
      title: t('features.items.2.title'),
      image: 'https://readdy.ai/api/search-image?query=Black%20African%20renewable%20energy%20technicians%20installing%20solar%20panels%20on%20industrial%20rooftop%20in%20Africa%2C%20professional%20solar%20energy%20installation%20team%20with%20dark%20skin%20wearing%20safety%20gear%2C%20modern%20photovoltaic%20system%20deployment%2C%20bright%20sunny%20day%20with%20blue%20sky%2C%20professional%20sustainable%20energy%20construction%20photography&width=848&height=520&seq=feat-solar-01&orientation=landscape',
      link: '/solutions',
    },
  ];

  return (
    <section className="py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center border border-primary-300/60 rounded-full px-4 py-1.5 mb-6">
            <span className="text-primary-600 text-xs font-semibold uppercase tracking-wider">{t('features.badge')}</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold font-heading text-foreground-950 max-w-3xl mx-auto leading-tight">
            {t('features.title')}
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6 animate-stagger">
          {features.map((feature) => (
            <Link
              key={feature.title}
              to={feature.link}
              className="group bg-white rounded-3xl overflow-hidden border border-background-200/70 hover:shadow-xl transition-all duration-500 cursor-pointer block"
            >
              <div className="flex items-center justify-between px-6 py-5">
                <h3 className="font-bold font-heading text-foreground-950 text-lg">
                  {feature.title}
                </h3>
                <div className="w-10 h-10 bg-primary-100 rounded-full flex items-center justify-center group-hover:bg-primary-500 transition-colors duration-300">
                  <i className="ri-arrow-right-up-line text-primary-600 group-hover:text-background-950 w-5 h-5 flex items-center justify-center transition-colors duration-300"></i>
                </div>
              </div>
              <div className="px-4 pb-4">
                <div className="rounded-2xl overflow-hidden h-52 md:h-60">
                  <img
                    src={feature.image}
                    alt={feature.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}